<template>
    <v-row>
        <v-col>
            <v-card>
                <v-toolbar>
                    <v-btn density="comfortable" prepend-icon="mdi-delete" @click="confirmDialog = true">Slett alle disse profilene </v-btn>
                    <v-dialog v-model="confirmDialog" max-width="290" persistent>
                        <v-card>
                            <v-card-text>Er du sikker på at du vil slette alle disse profilene?</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" flat @click="confirmDialog = false">Avbryt</v-btn>
                                <v-btn color="green darken-1" flat @click="deleteBlacklistedProfiles()">Ok</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <v-skeleton-loader v-if="props.loading"></v-skeleton-loader>
                <v-data-table-server
                    v-else
                    :headers="headers"
                    :items="profiles"
                    :items-length="paging.totalItemCount"
                    :items-per-page="paging.pageSize"
                    :items-per-page-options="DefaultPerPageOptions"
                    :page="paging.pageNumber"
                    @update:items-per-page="onItemsPerPageChange"
                    @update:page="onPageChange"
                >
                    <template #item.phone="{ item }">
                        {{ formatters.toFullPhone(item.phone) }}
                    </template>
                    <template #item.link="{ item }">
                        <router-link :to="{ name: ProfileRels.UpdateProfile, params: { id: item.id } }" class="card-link" target="_blank">
                            <v-tooltip activator="parent" location="start">Åpne profil</v-tooltip>
                            <v-icon icon="mdi-open-in-new" />
                        </router-link>
                    </template>
                </v-data-table-server>
            </v-card>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
import { VDataTableServer, VSkeletonLoader } from 'vuetify/components';
import { Paging } from '../shared/models';
import { Profile } from '../profiles/profilesModels';
import { ProfileRels } from '../profiles/rels';
import { useFormatters } from '../shared/formatters';
import { DefaultPerPageOptions } from '@/features/shared/models';
import { ref } from 'vue';

const formatters = useFormatters();

interface Props {
    profiles: Array<Profile>;
    paging: Paging;
    loading: boolean;
}

type Emits = {
    (e: 'perPageChange', pageSize: number): void;
    (e: 'pageChange', pageNumber: number): void;
    (e: 'deleteBlacklistedProfiles'): void;
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const headers = [
    {
        title: 'Fornavn',
        key: 'firstName',
        sortable: false
    },
    {
        title: 'Etternavn',
        key: 'lastName',
        sortable: false
    },
    {
        title: 'E-post',
        key: 'email',
        sortable: false
    },
    {
        title: 'Telefon',
        key: 'phone',
        sortable: false
    },
    {
        title: '',
        key: 'link',
        sortable: false
    }
];

const confirmDialog = ref(false);

function onPageChange(pageNumber: number) {
    emit('pageChange', pageNumber);
}

function onItemsPerPageChange(pageSize: number) {
    emit('perPageChange', pageSize);
}

function deleteBlacklistedProfiles() {
    emit('deleteBlacklistedProfiles');
    confirmDialog.value = false;
}
</script>

<style lang="scss" scoped>
.card-link {
    color: #000000;
}
</style>
